<template>
    <v-select :value="value" @change="selectionChanged" :label="label" :items="ranges"  :hint="hint" return-object />
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import {startOfMonth, endOfMonth, subMonths, subQuarters, startOfQuarter, lastDayOfQuarter} from 'date-fns'
import DateHelpers from '../helpers/DateHelpers'

export default {
    data() {
        return {
            ranges: []
        }
    },

    components: {

    },

    props: {
        value: Object,
        label: String,
        default: String, //eg 'Last Month'
    },

    computed: {

        hint() {
            if(!this.value)
                return 'Select a range...'
            if(!this.value.start && !this.value.end)
                return 'Showing all records'
            return 'From ' + DateHelpers.backwardsToAu(this.value.start) + ' to ' + DateHelpers.backwardsToAu(this.value.end)
        }
    },

    methods: {
        selectionChanged(value) {
            this.emitChanges(value)
        },
        emitChanges(value) {
            this.$emit('input', value)
            this.$emit('change', value)
        }
    },

    mounted() {

    },

    created() {

        const today = new Date()
        const oneMonthAgo = subMonths(today, 1)

        const lastQuarterStartDate = startOfQuarter(subQuarters(today,1))
        const lastQuarterEndDate = lastDayOfQuarter(subQuarters(today,1))
        const thisQuarterStartDate = startOfQuarter(today)
        const thisQuarterEndDate = lastDayOfQuarter(today)

        this.ranges.push({
            text: 'All',
            start: null,
            end: null
        })
        this.ranges.push({
            text: 'This month',
            start: DateHelpers.dateToBackwards(startOfMonth(today)),
            end: DateHelpers.dateToBackwards(endOfMonth(today))
        })
        this.ranges.push({
            text: 'Last month',
            start: DateHelpers.dateToBackwards(startOfMonth(oneMonthAgo)),
            end: DateHelpers.dateToBackwards(endOfMonth(oneMonthAgo))
        })
        this.ranges.push({
            text: 'Last Quarter',
            start: DateHelpers.dateToBackwards(startOfMonth(lastQuarterStartDate)),
            end: DateHelpers.dateToBackwards(endOfMonth(lastQuarterEndDate))
        })
        this.ranges.push({
            text: 'This Quarter',
            start: DateHelpers.dateToBackwards(startOfMonth(thisQuarterStartDate)),
            end: DateHelpers.dateToBackwards(endOfMonth(thisQuarterEndDate))
        })

        if(!this.value || (!this.value.start && !this.value.end) ) {
            let range = this.ranges[0]
            if(this.default)
                range = this.ranges.find(o => o.text == this.default) || range
            this.emitChanges(range)
        }

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// DateRangeList.vue?51ed4b7c